import {MOON_150} from '@wandb/weave/common/css/color.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import React from 'react';

import {CodeSnippet} from '../components/CodeSnippet';
import {SemanticLoader as Loader} from '../components/utility/InstrumentedLoader';
import {useViewerApiKeyQuery} from '../generated/graphql';

interface WandbLoginExampleProps {
  apiKey: string;
}

const WandbLoginExample: React.FC<WandbLoginExampleProps> = ({apiKey}) => {
  let args = '';
  // Add the local instance host when not running in the cloud
  if (!document.location.origin.includes('wandb.ai')) {
    args = ' --host=' + document.location.origin;
  }
  return (
    <CodeSnippet
      codeSnippet={`wandb login${args} ${apiKey}`}
      codeLanguage="bash"
      backgroundColor={MOON_150}
    />
  );
};

export const NoRunsSampleScript: React.FC = () => {
  const {data, loading} = useViewerApiKeyQuery();
  if (loading) {
    return <Loader name="no-runs-sample-script-loader" />;
  }

  return (
    <div className="project-getting-started">
      <h2>Example Project</h2>
      <p>
        Copy the following commands in your terminal to clone a simple Keras
        training script and log the results to wandb.
      </p>
      <div className="code-snippets">
        <CodeSnippet
          codeSnippet="git clone http://github.com/wandb/tutorial"
          codeLanguage="bash"
          backgroundColor={MOON_150}
        />
        <CodeSnippet
          codeSnippet="cd tutorial; pip install --upgrade -r requirements.txt;"
          codeLanguage="bash"
          backgroundColor={MOON_150}
        />
        {/* eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain */}
        <WandbLoginExample apiKey={data?.viewer?.apiKey!} />
        <CodeSnippet
          codeSnippet="python tutorial.py"
          codeLanguage="bash"
          backgroundColor={MOON_150}
        />
      </div>
      <div />
      <p>
        If you would like to find more examples of training scripts instrumented
        with wandb, check out our{' '}
        <TargetBlank href="https://github.com/wandb/examples">
          examples repository
        </TargetBlank>
        .
      </p>
    </div>
  );
};
